import React from 'react'
import { StyledChatItem } from './ChatItem.style';
import { getImageUrlByPath } from '@/Services/Image';
import Image from '@/Components/atoms/Image';
import { IOfferedDealProductDto } from '@/Models/Chat';
import { useTranslation } from 'next-i18next';
import BaseButton from '@/Components/atoms/BaseComponents/BaseButton';
import { useConfirm } from "@/Hooks/useConfirm";


export type dealActionType = 'cancel' | 'sell';

type Props = {
  item: IOfferedDealProductDto;
  action: (id: number, actionType: dealActionType) => Promise<void>;
  disabled?: boolean;
  cancelLoading: boolean;
  sellLoading: boolean;
}

const ChatDealItem = ({ item, action, disabled }: Props) => {
  const { t } = useTranslation();
  const confirm = useConfirm();

  const cancelBtn = () => {
    confirm({ description: t('will_you_cancel'), confirmationText: t("common:yes"), cancellationText: t("common:no") })
    .then(() => {
        action(item.offerId, 'cancel');
      }, () => {});
  }

  const sellBtn = () => {
    confirm({ description: t('have_you_sold'), confirmationText: t("common:yes"), cancellationText: t("common:no") })
    .then(() => {
        action(item.offerId, 'sell');
      }, () => {});
  }
  

  return (
    <StyledChatItem className='chat-item'>
      <div className='chat-item__inner'>
        <div className='chat-item__img-wrapper'>
          <Image className='chat-item__img' src={getImageUrlByPath(item.imagePath, 200, 200)} alt='' />
        </div>
        <div className='chat-item__text-wrapper'>
          <div className='chat-item__title-wrapper'>
            <h5 className='chat-item__title'>{ item.name }</h5>
            {/* <span className='chat-item__date'>
              { DateService.toHHMM(item.createdAt) }
            </span> */}
          </div>
          <p className='chat-item__description'>{ item.name }</p>
          <p className='chat-item__description'>{ t('offer') + ': ' + item.offerPrice + ' ' + t(item.currencyType) }</p>
          <div className='chat-item__actions'>
            <BaseButton btnType='primary-outlined' className='chat-item__action-btn' type='button' onClick={cancelBtn} disabled={disabled}>
              { t('cancel') }
            </BaseButton>
            <BaseButton btnType='primary' className='chat-item__action-btn' type='button' onClick={sellBtn} disabled={disabled}>
              { t('sell') }
            </BaseButton>
          </div>
        </div>
      </div>
    </StyledChatItem>
  )
}

export default ChatDealItem;
